import { getDocument, getSubDocument } from '../../../../firebase/firestore'
import { ExportToExcel } from '../../../../utils/exportToExcel'
import { TryCatch } from '../../../../utils/general'
import { DestructureData } from './destructureData'
import { GetAllStaffDataEnriched } from './getAllStaff'

const schemaSpreadsheet = (values, columns) => {
  const newSchema = columns.map((column) => ({
    label: column?.name || column?.column?.label || 'não encontrado',
    value: column?.column?.value || 'não encontrado',
  }))

  // console.log(newSchema)
  const destructureData = DestructureData(values, newSchema)
  // console.log(destructureData)
  return destructureData
}

const CreateOrderKeys = (firstKeys) => {
  // separa keys com [n] e sem [n]
  const normalKeys = firstKeys.filter((k) => !k.includes('['))
  const formKeys = firstKeys.filter((k) => k.includes('['))

  // agrupa por índice [n]
  const grouped = {}
  formKeys.forEach((k) => {
    const match = k.match(/\[([0-9]+)\]/)
    if (match) {
      const idx = match[1]
      if (!grouped[idx]) grouped[idx] = []
      grouped[idx].push(k)
    }
  })

  // reordena: todas as keys dentro do mesmo [n] em ordem alfabética
  const sortedFormKeys = []
  Object.keys(grouped)
    .sort((a, b) => a - b) // garante ordem numérica dos índices
    .forEach((idx) => {
      const keys = grouped[idx].sort() // ordena alfabeticamente
      sortedFormKeys.push(...keys)
    })

  // ordem final
  const orderKeys = [...normalKeys, ...sortedFormKeys]

  return orderKeys
}

// função para ordenar um objeto pela ordem da primeira linha
const sortObjectByFirstLine = (obj, orderKeys) => {
  const sorted = {}
  orderKeys.forEach((key) => {
    if (key in obj) {
      sorted[key] = obj[key]
    } else {
      sorted[key] = '-'
    }
  })
  return sorted
}

const ExportSpreadsheet = async (idClient, idReport, typeReport, idEvent, setAlerts) => {
  let reportSchema = {}
  // console.log(typeReport)
  // console.log(idReport)
  if (typeReport === 'client') {
    reportSchema = await getSubDocument('clients', idClient, 'reports', idReport)
  } else {
    reportSchema = await getDocument('reports', idReport)
  }

  // console.log(reportSchema)

  const columnsReport = reportSchema?.columns || []
  const filtersReport = reportSchema?.filters || []

  if (columnsReport.length === 0) {
    return setAlerts((prev) => [
      ...prev,
      {
        type: 'error',
        title: `Nenhuma coluna encontrada`,
        msg: 'Não encontramos nenhuma coluna no relatório, revise-o ou entre em contato com o suporte.',
      },
    ])
  }

  if (filtersReport.length === 0) {
    return setAlerts((prev) => [
      ...prev,
      {
        type: 'error',
        title: `Nenhuma filtro encontrado`,
        msg: 'Não encontramos nenhum filtro no relatório, revise-o ou entre em contato com o suporte.',
      },
    ])
  }

  // trocar a coleta do schema pra fora pra poder coletar os filtros novos
  const getInfosEvent = await getDocument('events', idEvent)

  setAlerts((prev) => [
    ...prev,
    {
      type: 'success',
      title: `${reportSchema?.name}`,
      msg: 'Estamos coletando as informações necessárias para gerar sua planilha. Esse processo pode levar alguns minutos...',
    },
  ])

  const allStaff = await GetAllStaffDataEnriched(idEvent)

  // console.log(allStaff)
  // console.log(allStaff.length)

  const filters = filtersReport.map((item) => Number(item.value))

  // filtra a staff pelo status registrados no relatorio
  // [1, 2, 6].includes(candidate.candidacy.status)
  const staffFiltered = allStaff.filter((candidate) => filters.includes(candidate.candidacy.status))

  if (staffFiltered.length === 0) {
    return setAlerts((prev) => [
      ...prev,
      {
        type: 'error',
        title: `Nenhum Membro na Staff`,
        msg: 'Aplicamos o filtro conforme o relatório, mas não encontramos membros na equipe do evento para exportação. Verifique os critérios do filtro ou entre em contato com o suporte para mais informações.',
      },
    ])
  }

  // console.log(staffFiltered)
  // console.log(staffFiltered.length)

  const dataSpreadSheet = staffFiltered.flatMap((candidate) => {
    return schemaSpreadsheet(candidate, columnsReport)
  })

  const getMaxKeys = (arr) => {
    if (!arr || arr.length === 0) return []

    const biggest = arr.reduce((max, obj) => {
      if (!obj) return max
      return Object.keys(obj).length > Object.keys(max).length ? obj : max
    }, {})

    return Object.keys(biggest)
  }
  const firstMaxKeys = CreateOrderKeys(getMaxKeys(dataSpreadSheet) || [])

  // aplica para todos os objetos
  const sortedDataSpreadSheet = dataSpreadSheet.map((item) => sortObjectByFirstLine(item, firstMaxKeys))

  const spreadSheet = [{ sheet: sortedDataSpreadSheet, nameSheet: 'Planilha1' }]

  const nameSpreadSheet = reportSchema?.name.replace('Exportar', '').trim().replace(/ /g, '_')

  ExportToExcel(spreadSheet, `${nameSpreadSheet}_${getInfosEvent.name}.xlsx`)

  return setAlerts((prev) => [
    ...prev,
    {
      type: 'success',
      title: `Planilha de Credenciamento Conclúida`,
      msg: 'O Processo de construir sua planilha terminou com exito...',
    },
  ])
}

export const HandleExportSpreadsheet = async (idClient, idReport, typeReport, idEvent, setLoading, setAlerts) => {
  const callback = async () => {
    ExportSpreadsheet(idClient, idReport, typeReport, idEvent, setAlerts)
  }
  await TryCatch(callback, setLoading, setAlerts)
}
